<template>
  <div class="tw-font-bold tw-text-4.5xl tw-text-neutral-900 tw-leading-none">
    <slot />
  </div>
</template>
